// قائمة الدول المدعومة لـ WhatsApp
export interface Country {
  code: string;
  name: string;
  nameEn: string;
  flag: string;
  phoneDigits: number;
}

export const SUPPORTED_COUNTRIES: Country[] = [
  {
    code: '20',
    name: 'مصر',
    nameEn: 'Egypt',
    flag: '🇪🇬',
    phoneDigits: 11
  },
  {
    code: '966',
    name: 'السعودية',
    nameEn: 'Saudi Arabia',
    flag: '🇸🇦',
    phoneDigits: 11
  },
  {
    code: '971',
    name: 'الإمارات',
    nameEn: 'UAE',
    flag: '🇦🇪',
    phoneDigits: 10
  },
  {
    code: '965',
    name: 'الكويت',
    nameEn: 'Kuwait',
    flag: '🇰🇼',
    phoneDigits: 8
  },
  {
    code: '973',
    name: 'البحرين',
    nameEn: 'Bahrain',
    flag: '🇧🇭',
    phoneDigits: 8
  },
  {
    code: '974',
    name: 'قطر',
    nameEn: 'Qatar',
    flag: '🇶🇦',
    phoneDigits: 8
  },
  {
    code: '968',
    name: 'عُمان',
    nameEn: 'Oman',
    flag: '🇴🇲',
    phoneDigits: 8
  },
  {
    code: '962',
    name: 'الأردن',
    nameEn: 'Jordan',
    flag: '🇯🇴',
    phoneDigits: 9
  },
  {
    code: '961',
    name: 'لبنان',
    nameEn: 'Lebanon',
    flag: '🇱🇧',
    phoneDigits: 8
  },
  {
    code: '963',
    name: 'سوريا',
    nameEn: 'Syria',
    flag: '🇸🇾',
    phoneDigits: 9
  },
  {
    code: '964',
    name: 'العراق',
    nameEn: 'Iraq',
    flag: '🇮🇶',
    phoneDigits: 10
  },
  {
    code: '967',
    name: 'اليمن',
    nameEn: 'Yemen',
    flag: '🇾🇪',
    phoneDigits: 9
  },
  {
    code: '212',
    name: 'المغرب',
    nameEn: 'Morocco',
    flag: '🇲🇦',
    phoneDigits: 9
  },
  {
    code: '213',
    name: 'الجزائر',
    nameEn: 'Algeria',
    flag: '🇩🇿',
    phoneDigits: 9
  },
  {
    code: '216',
    name: 'تونس',
    nameEn: 'Tunisia',
    flag: '🇹🇳',
    phoneDigits: 8
  },
  {
    code: '218',
    name: 'ليبيا',
    nameEn: 'Libya',
    flag: '🇱🇾',
    phoneDigits: 9
  },
  {
    code: '249',
    name: 'السودان',
    nameEn: 'Sudan',
    flag: '🇸🇩',
    phoneDigits: 9
  },
  {
    code: '90',
    name: 'تركيا',
    nameEn: 'Turkey',
    flag: '🇹🇷',
    phoneDigits: 10
  },
  {
    code: '98',
    name: 'إيران',
    nameEn: 'Iran',
    flag: '🇮🇷',
    phoneDigits: 10
  },
  {
    code: '92',
    name: 'باكستان',
    nameEn: 'Pakistan',
    flag: '🇵🇰',
    phoneDigits: 10
  },
  {
    code: '91',
    name: 'الهند',
    nameEn: 'India',
    flag: '🇮🇳',
    phoneDigits: 10
  },
  {
    code: '1',
    name: 'الولايات المتحدة',
    nameEn: 'United States',
    flag: '🇺🇸',
    phoneDigits: 10
  },
  {
    code: '44',
    name: 'المملكة المتحدة',
    nameEn: 'United Kingdom',
    flag: '🇬🇧',
    phoneDigits: 10
  },
  {
    code: '33',
    name: 'فرنسا',
    nameEn: 'France',
    flag: '🇫🇷',
    phoneDigits: 9
  },
  {
    code: '49',
    name: 'ألمانيا',
    nameEn: 'Germany',
    flag: '🇩🇪',
    phoneDigits: 11
  },
  {
    code: '39',
    name: 'إيطاليا',
    nameEn: 'Italy',
    flag: '🇮🇹',
    phoneDigits: 10
  },
  {
    code: '34',
    name: 'إسبانيا',
    nameEn: 'Spain',
    flag: '🇪🇸',
    phoneDigits: 9
  }
];

// البحث عن دولة بالكود
export const getCountryByCode = (code: string): Country | undefined => {
  return SUPPORTED_COUNTRIES.find(country => country.code === code);
};

// البحث عن دولة بالاسم
export const getCountryByName = (name: string): Country | undefined => {
  return SUPPORTED_COUNTRIES.find(country => 
    country.name === name || country.nameEn.toLowerCase() === name.toLowerCase()
  );
};

// الحصول على الدولة الافتراضية (مصر)
export const getDefaultCountry = (): Country => {
  return getCountryByCode('20') || SUPPORTED_COUNTRIES[0];
};
